// REQUIREMENT: Add element with ID of "custom-cart-sharing-btn"

// Check if there is a cart sharing link within the URL
document.addEventListener('DOMContentLoaded', async () => {

  // total URL
  const currentUrl = new URL(window.location.href);
  // console.log('Current URL: ', currentUrl);

  // The cart sharing parameters
  const rawLink = currentUrl.searchParams.get('cart-share');
  if (!rawLink) {
    // console.log('No cart sharing parameters found');
    return;
  } else {

    // Allow the parent to be displayed so that we are not hiding the entire popup
    const parent = document.querySelector('div#quickViewWrapper');
    console.log('Parent: ', parent);
    if (parent) {
      parent.style.visibility = 'visible';
      parent.style.opacity = '1';
    };

    // cart-share parameter found, so build redirect popup
    const popupContainer = document.createElement('div');
    popupContainer.classList.add('cart-share-popup-container');
    document.querySelector('body > div').appendChild(popupContainer);
    Object.assign(popupContainer.style, {
      position:      'absolute',
      top:           '150px',
      left:          '50%',
      transform:     'translateX(-50%)',
      zIndex:        '25',
      background:    'white',
      color:         'black',
      padding:       '2rem',
      borderRadius:  '5px',
      display:       'flex',
      flexDirection: 'column',
    });

    const cartShareText = document.createElement('p');
    cartShareText.textContent = 'Adding shared items in your cart to check out';
    popupContainer.appendChild(cartShareText);

    const loadingAnimation = document.createElement('img');
    loadingAnimation.src = 'https://cdn.shopify.com/s/files/1/0403/6005/0839/files/loading-aniamtion.gif?v=1737738212';
    loadingAnimation.classList.add('cart-share-popup-loader');
    popupContainer.appendChild(loadingAnimation);
    Object.assign(loadingAnimation.style, {
      maxHeight: '70px',
      margin: '0 auto',
      width: 'auto'
    });
  };

  // Split URL into each item
  const splitUrl = rawLink.split(',');

  // Separate item and quantity
  const cartItemArray = splitUrl.map(entry => {
    // skip any empty strings
    if (!entry.trim()) return null;

    const [idPart, qtyPart] = entry.split(':');

    // Parse numbers; idPart should always be present
    const variantId = Number(idPart);
    
    // qtyPart might be undefined or non-numeric → fallback to 1
    const qty = qtyPart ? Number(qtyPart) || 1 : 1;

    // If variantId didn’t parse to a number, skip this entry
    if (Number.isNaN(variantId)) return null;

    return { variantId, qty };
  });

  // Filter for any null values
  const itemArray = cartItemArray.filter(item => item !== null);
  // console.log('itemArray: ', itemArray);

  // Add each item to the cart
  for (const item of itemArray) {
    await addVariantToCart(item.variantId, item.qty);
  };

  // Direct the user to checkout after 2 seconds
  setTimeout(() => {
    window.location.href = "/checkout";
  }, 2000);
  
});

// Callback for adding variants to the cart
async function addVariantToCart(variantId, quantity) {
  const data = {
    id: variantId,
    quantity: quantity
  };

  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(data)
    });

    if (response.ok) {
      console.log(`Variant ${variantId} added with quantity ${quantity}`);
    } else {
      console.error(`Failed to add variant ${variantId}`);
    }
  } catch (error) {
    console.error("Error adding variant to cart:", error);
  }
}

// Add the event listener on the element with the ID of "custom-cart-sharing-btn"
document.addEventListener('DOMContentLoaded', async () => {

  //  Check for the cart sharing button after page load
  const customCartSharingTool = document.querySelector('#custom-cart-sharing-btn');

  // If present, add event listener to share cart
  if (customCartSharingTool) {
    customCartSharingTool.addEventListener('click', async (e) => {

      // Open the cart popup again
      const cartIcon = document.querySelector('#cart > button');
      console.log('cartIcon: ', cartIcon);
      if (cartIcon) {
        setTimeout(() => {
          cartIcon.click();
          console.log('Cart button clicked');
        }, 10);
      };
    
      // generate the link
      const link = await createShareableLink();

      const shareData = {
        title: `TunerDepot.com's Cart-Sharing Link:`,
        text: `${link}`,
        // url: window.location.href
      };


      // Display the share if the Web Share API is available
      if (navigator.share) {
        try {
          await navigator.share(shareData);
          // console.log('✅ Shared successfully');
        } catch (err) {
          console.error('❌ Share failed:', err);
        };
      } else {

        // Just copy to the clipboard
        try {
          await navigator.clipboard.writeText(shareData);
          alert('Link copied to clipboard. You can now paste it into Notes, Mail, Messages, etc.');
        } catch (err) {
          // Last-ditch fallback: prompt
          prompt('Copy this link:', shareData.url);
        }
      };
      
    });
  } else {
    console.log('Cart sharing button with an ID of #custom-cart-sharing-btn is missing');
  };
});

// Link generating callback function
async function createShareableLink() {

  try {
    
    const response = await fetch('/cart.js');
    if (!response.ok) {
      console.log('Failed to fetch the cart values.');
      return;
    };

    const cart = await response.json();
    if (cart.items && cart.items.length > 0) {

      // fetch the variants and quantities fro the cart
      const variants = cart.items.map(item => `${item.variant_id}:${item.quantity}`);

      // generate the link
      const wishlistLink = `${window.location.origin}?cart-share=${variants.join(',')}`;
      // console.log('The link to share: ', wishlistLink);
      return wishlistLink;
    };
    
  } catch (error) {
    console.log('Failed to run createShareableLink')
  };
};